<layout>
  <div class="lessonContainer">
    <button
      *ngIf="selectedLesson != null"
      mat-raised-button
      raised
      (click)="deselectLesson()"
    >
      Back
    </button>
    <div *ngFor="let card of cards">
      <div
        *ngIf="!selectedLesson || selectedLesson?.id === card.id"
        class="row"
        (click)="setSelectedCard(card)"
      >
        <div class="image-and-text">
          <img src="{{ card.img }}" alt="{{ card.title }}" />
          <h2>{{ card.title }}</h2>
        </div>
        <mat-checkbox
          (click)="dontPropagate($event)"
          (change)="toggleLessonCompletion($event, card)"
          [checked]="config?.completed[card.id]"
        ></mat-checkbox>
      </div>
    </div>

    <div *ngFor="let question of questions | slice : 1" class="inset">
      <div *ngIf="questions && question.questionID === selectedQuestion">
        <question *ngIf="questions && preview" [question]="question"></question>
        <question-editor
          *ngIf="!preview"
          [question]="question"
        ></question-editor>
        <div>
          <button
            *ngIf="selectedQuestion != null"
            mat-raised-button
            raised
            (click)="previousQuestion()"
          >
            Back
          </button>
          <button
            *ngIf="selectedQuestion != null"
            mat-raised-button
            raised
            (click)="nextQuestion()"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</layout>
